export const getImagePreview = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result);
    };

    reader.readAsDataURL(file);
  });

const handleError = (reject) => () => {
  const dimensions = {
    width: null,
    height: null,
  };

  reject(dimensions);
};

export const getImageDimensions = (imageDataURL) =>
  new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = () => {
      const dimensions = {
        width: img.width,
        height: img.height,
      };

      resolve(dimensions);
    };
    img.onerror = handleError(reject);
    img.onabort = handleError(reject);

    img.src = imageDataURL;
  });

export const isDataUrl = (string = '') => string.startsWith('data:image');

export const isDefaultImage = (url) =>
  !!url && url.startsWith('/images/missing');
